<nz-collapse [nzBordered]="false" nzGhost>
  <nz-collapse-panel
    #userPanel
    class="collapse-panel"
    [nzHeader]="qualificationHistorySectionHeader"
    [nzActive]="
      userQualificationHistories && userQualificationHistories.length > 0
        ? true
        : false
    "
    [nzCollapsible]="
      (
        userQualificationHistories && userQualificationHistories.length > 0
          ? false
          : true
      )
        ? 'disabled'
        : undefined
    "
  >
    <div class="details-grid">
      <wilson-qualification-version-list
        [qualificationVersions]="userQualificationHistories"
      ></wilson-qualification-version-list>
    </div>
  </nz-collapse-panel>

  <ng-template #qualificationInfoSectionHeader>
    <div class="d-flex justify-content-between">
      <span class="header-text">
        {{ 'general.title' | translate }}
      </span>
    </div>
  </ng-template>
  <ng-template #qualificationHistorySectionHeader>
    <div class="d-flex justify-content-between">
      <span class="header-text">
        {{ 'page.qualifications.drawer.hostory' | translate }}
      </span>
    </div>
  </ng-template>
</nz-collapse>
